import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefService } from "../services/brief.service";

export type BriefXlsxDownloadType =
  "addCreators" | "editCreators" | "accountManager";

function saveBlobFile(blob: Blob, filename: string) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

export function useDownloadBriefXlsx() {
  const { mutate: downloadBriefXlsx, isLoading: isDownloadingXlsx } =
    useMutation({
      mutationFn: (payload: {
        briefId: string;
        type?: BriefXlsxDownloadType;
      }) => {
        const type = payload.type ?? "addCreators";
        return BriefService.downloadBriefXlsx(payload.briefId, type).catch(
          async (err: { response?: Response }) => {
            try {
              const responseBody = (await err.response?.json()) as {
                msg?: string;
              };
              ToastService.error(
                responseBody?.msg || "Failed to download Excel template"
              );
            } catch {
              ToastService.error("Failed to download Excel template");
            }
            throw err;
          }
        );
      },
      options: {
        skipInvalidation: true,
      },
      onSuccess: (_c, file, params) => {
        const type = params.type ?? "addCreators";
        saveBlobFile(
          file.blob,
          file.filename || `${params.briefId}-${type}.xlsx`
        );
        ToastService.success("Excel downloaded successfully");
      },
    });

  return {
    downloadBriefXlsx,
    isDownloadingXlsx,
  };
}
